export enum Partner {
  WORKWHILE = "workwhile",
  WALMART = "walmart",
  SAMS_CLUB = "sams_club",
}

// Partners that are considered "membership" providing by the system. They prescribe elgibility and
// affiliation concepts that users must match against to receive benefits.
const MEMBERSHIP_PARTNERS: Partner[] = [Partner.WORKWHILE];

// Partners that are considered "marketplace" providing by the system. They are not considered membership partners,
// but are still considered partners of the system. Practically this is used for reporting and tracking
// purposes more than anything else.
const MARKETPLACE_PARTNERS: Partner[] = [Partner.WALMART, Partner.SAMS_CLUB];

export const ALL_PARTNERS: Partner[] = [
  ...MEMBERSHIP_PARTNERS,
  ...MARKETPLACE_PARTNERS,
];

export const isMembershipPartner = (partner: string) => {
  return MEMBERSHIP_PARTNERS.includes(partner as Partner);
};

export const isMarketplacePartner = (partner: string) => {
  return MARKETPLACE_PARTNERS.includes(partner as Partner);
};
